<template>
  <div>
    <h1 class="display-3">Działalność bojowa Oddziałów i Brygad</h1><br/>
    <b-row class="justify-content-md-center">
      <b-col cols="11">
        <b-img center fluid src="/historia/dzialalnosc_bojowa/mapa_potyczek_walk.jpg"/><br/>
      </b-col>
      <b-col cols="6">
        <span class="lead">
          Mapa usytuowania miejsc potyczek i walk Oddziałów zbrojnych
          Armii Krajowej Okręgu Wileńskiego w okresie 1943 i 1944.
        </span>
      </b-col>
    </b-row>

    <b-row class="justify-content-md-center mt-5">
      <b-col md="11">
        <p>Brygady i Oddziały Okręgu Wileńskiego Armii Krajowej (kolejność wg rozpoczęcia działań)</p>
        <b-table striped hover :items="brygady" :fields="fields">
          <template slot="link" slot-scope="data">
            <a v-if="data.value" target="_blank" :href="data.value">link</a>
          </template>
        </b-table>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import dzialalnosc_bojowa from '@/models/historia/dzialalnosc_bojowa'
export default {
  name: 'dzialalnosc_bojowa',
  data: function(){
    return{
      fields: ['brygada','data','link'],
      brygady: dzialalnosc_bojowa.brygady
    }
  },
  metaInfo:{
    title: 'Działalność bojowa Oddziałów i Brygad',
    meta:[
      {name: 'description', content: 'Brygady i Oddziały Okręgu Wileńskiego Armii Krajowej (kolejność wg rozpoczęcia działań)' },
      {name: 'og:url', content: 'http://akwilno.pl/historia/dzialalnosc_bojowa' },
      {name: 'og:title', content: 'Działalność bojowa Oddziałów i Brygad' },
      {name: 'og:image', content: '/historia/dzialalnosc_bojowa.jpg' },
      {name: 'og:description', content: 'Brygady i Oddziały Okręgu Wileńskiego Armii Krajowej (kolejność wg rozpoczęcia działań)' },
      {name: 'twitter:url', content: 'http://akwilno.pl/historia/dzialalnosc_bojowa' },
      {name: 'twitter:title', content: 'Działalność bojowa Oddziałów i Brygad' },
      {name: 'witter:image', content: '/historia/dzialalnosc_bojowa.jpg' },
      {name: 'twitter:description', content: 'Brygady i Oddziały Okręgu Wileńskiego Armii Krajowej (kolejność wg rozpoczęcia działań)' }
    ]
  }
}
</script>



// WEBPACK FOOTER //
// src/components/historia/dzialalnosc_bojowa.vue